// Domain constants/enums for the pslf-form resource (relocated from the legacy Model in wave 4.3 ahead of models/ deletion).

/** Statuses representing a form that has been submitted to the government. */
export const SUBMITTED_STATUSES = ['submitted', 're_submitted'] as const;

/** Statuses representing a submit attempt that's in-flight (being faxed). */
export const PENDING_SUBMIT_STATUSES = ['submit_pending', 're_submit_pending'] as const;

/** Statuses where the form has been signed but not yet submitted. */
export const PENDING_SIGNATURE_STATUSES = [
  'borrower_signed',
  'employer_signed',
  'awaiting_submit',
] as const;

/** Statuses considered "active" (worth surfacing in alerts / dashboards). */
export const ACTIVE_STATUSES = [
  ...SUBMITTED_STATUSES,
  ...PENDING_SUBMIT_STATUSES,
  ...PENDING_SIGNATURE_STATUSES,
] as const;

/** Statuses representing a terminal/dead form. */
export const INACTIVE_STATUSES = ['rejected', 'cancelled', 'expired', 'abandoned'] as const;

/** ~12 months: a submitted form is still considered "recent". */
export const ONE_YEAR_DAYS = 365;

/** ~11 months: nudge the user to recertify / show an "expiring" hint. */
export const RECERT_WARNING_DAYS = 335;
